import { useState } from "react";
import { createTestimonial } from "../graphql/mutations";
import { generateClient } from 'aws-amplify/api';

interface ReviewProps {
  onClose: () => void; 
}

const AddReviewPage: React.FC<ReviewProps> = ({ onClose }) => {
  const [body, setBody] = useState<string>("");
  const [name, setName] = useState<string>("");
  const [formError, setFormError] = useState<string>("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setFormError("");

    if (!body || !name) {
      setFormError("Please fill in all fields.");
      return;
    }

    try {
      const data = { body, name };
      const client = generateClient();
      const result = await client.graphql({
        query: createTestimonial,
        variables: { input: data },
      });

      if (result) {
        alert("Review added successfully!");
        onClose(); 
      }
    } catch (error: any) {
      setFormError(error.message || "An error occurred while adding the review.");
    }
  };

  return (
    <div className="main">
      <div className="border p-5 rounded-3xl shadow-lg mx-auto mt-20 bg-white max-w-md">
        <h1 className="text-2xl mb-4 font-bold text-center">Add Review</h1>
        <form onSubmit={handleSubmit} className="space-y-4 md:space-y-6">
          <div>
            <label htmlFor="name" className="block mb-2 text-sm font-medium text-gray-900">
            Participant Name
            </label>
            <input
              type="text"
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5"
              placeholder="Enter your name"
              required
            />
          </div>
          <div>
            <label htmlFor="body" className="block mb-2 text-sm font-medium text-gray-900">
              Review
            </label>
            <textarea
              id="body"
              value={body}
              onChange={(e) => setBody(e.target.value)}
              rows={4}
              className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5"
              placeholder="Write your review here"
              required
            />
          </div>
          {formError && <p className="text-red-500 text-sm">{formError}</p>}
          <button
            type="submit"
            className="w-full text-white bg-blue-600 hover:bg-blue-700 rounded-lg text-sm px-5 py-2.5 text-center font-bold"
          >
            Submit Review
          </button>
        </form>
        <div className="mt-4 text-center">
          <button type="button" onClick={onClose} className="cancel-button">
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddReviewPage;
